export default "__VITE_ASSET__1EQmDLj3__"